<div class="card stickyCard">
  <div class="card-header-white header-underline">
    <h6 class="white-header-text">
      {{ team.groupName }} ({{ team.groupId }})
    </h6>
    <span
      class="float-right cursorPointer white-header-xmark-icon"
      (click)="closeEditForm()"
      ><span class="fa-light fa-xmark"></span
    ></span>
  </div>

  <div class="card-body-white">
    <div [formGroup]="teamEditForm">
      @if (!team?.locationId && featureEnabled('DigitalKey') && (Areas.DevicesLocks | can)) {
        <div
          class="mb-2"
          >
          <ul class="list-inline">
            <li class="list-inline-item">
              <span
                class="editPageTab"
                            [ngClass]="{
                                'editPageTab-active': activeTab === 1
                            }"
                (click)="activeTab = 1"
                >{{ "INFORMATION" | translate }}</span
                >
              </li>
              <li class="list-inline-item">
                <span
                  class="editPageTab"
                            [ngClass]="{
                                'editPageTab-active': activeTab === 2
                            }"
                  (click)="activeTab = 2"
                  >{{ "LOCK_ACCESS_RIGHTS" | translate }}</span
                  >
                </li>
              </ul>
            </div>
          }
          @if (activeTab === 2) {
            <team-lock-access
              [locations]="allLocations"
              [team]="team"
            ></team-lock-access>
          }
          @if (activeTab === 1) {
            <div>
              <div class="form-group">
                <label
                  ><strong>{{ "NAME" | translate }}</strong></label
                  >
                  <input
                    class="form-control"
                    type="text"
                    placeholder="{{ team.groupName }}"
                    formControlName="groupName"
                    />
                  </div>
                  @if (team?.locationName) {
                    <div class="form-group">
                      <strong>{{ "LOCATION" | translate }}:</strong>
                      {{ team?.locationName }} ({{ team?.locationId }})
                    </div>
                  }
                  <div class="form-group">
                    <mat-slide-toggle formControlName="teamLocked"
                      >{{ "LOCKED" | translate }}
                      <span
                        matTooltip="{{ 'TOOLTIP_TEAM_LOCKED' | translate }}"
                        class="fa fa-fw fa-info-circle"
                        ></span
                      ></mat-slide-toggle>
                      @if (user.roleLevel >= 200) {
                        <mat-slide-toggle
                          formControlName="teamHidden"
                          class="ml-3"
                          >{{ "HIDDEN" | translate }}
                          <span
                            matTooltip="{{ 'TOOLTIP_TEAM_HIDDEN' | translate }}"
                            class="fa fa-fw fa-info-circle"
                            ></span
                          ></mat-slide-toggle>
                        }
                      </div>
                      <div class="form-group">
                        <label class="d-flex justify-content-between rightMargin"
                          ><strong>{{ "STAFF_MEMBERS" | translate }}</strong>
                          <mat-checkbox
                            data-testid="team-select-all"
                            [checked]="allShownSelected()"
                            (change)="toggleAllSelection()"
                            [labelPosition]="'before'">
                            <strong>{{ "SELECT_ALL" | translate }}</strong>
                          </mat-checkbox>
                        </label>
                        <!-- Search and role filter, shared with the alarm route recipients (ES-7564) -->
                        <staff-filter-bar class="mb-2" [search]="search"></staff-filter-bar>
                        @if (search.active && shownStaff(availableStaffForCompany).length + shownStaff(availableStaffForLocation).length === 0) {
                          <p class="text-muted small" data-testid="team-staff-search-empty">{{ 'SEARCH_NOT_FOUND' | translate }}</p>
                        }
                        <mat-selection-list
                          #teamMembers
                          formControlName="selectedTeamMembers"
                          class="staff-container"
                          dense="true"
                          >
                          @for (staff of availableStaffForCompany; track staff) {
                            <mat-list-option [value]="staff.id" [class.d-none]="!isShown(staff)">
                  <span [ngClass]="staffIcon(staff)"></span> {{ staff.fullName }}
                </mat-list-option>
                          }
                          @if (shownStaff(availableStaffForLocation).length > 0) {
                            <span
                              matSubHeader
                              >{{ "LOCATION_MEMBERS" | translate }}</span
                              >
                          }
                          @for (staff of availableStaffForLocation; track staff) {
                            <mat-list-option [value]="staff.id" [class.d-none]="!isShown(staff)">
                  <span [ngClass]="staffIcon(staff)"></span> {{ staff.fullName }}
                </mat-list-option>
                          }
                        </mat-selection-list>
                      </div>
                      @if (!deleteConfirmation) {
                        <!-- Buttons wrap on narrow screens instead of overflowing the card -->
                        <div class="form-group form-buttons">
                          <button
                            [disabled]="teamEditForm.invalid"
                            type="submit"
                            (click)="editTeam()"
                            class="btn btn-primary"
                            >
                            <span class="fa-light fa-floppy-disk"></span>
                            {{ "SAVE" | translate }}
                          </button>
                          <button
                            type="reset"
                            class="btn btn-outline-primary"
                            (click)="closeEditForm()"
                            >
                            <span class="fa-light fa-xmark"></span>
                            {{ "CANCEL" | translate }}
                          </button>
                          @if (Areas.ReceiverTeams | can: 'ReadWrite') {
                            <span
                              class="btn btn-outline-danger ml-auto cursorPointer"
                              (click)="deleteConfirmation = true"
                              ><span class="fa-light fa-trash-alt"></span>
                              {{ "DELETE" | translate }}</span
                              >
                            }
                            @if (editTeamFormError) {
                              <div
                                class="alert alert-danger mt-2 w-100"
                                >
                                {{ editTeamFormError }}
                              </div>
                            }
                          </div>
                        }
                        @if (deleteConfirmation) {
                          <div class="form-group">
                            <p>
                              {{
                              "GROUP_DELETE_CONFIRMATION"
                              | translate : { groupname: team.groupName }
                              }}
                            </p>
                            <span
                              class="btn btn-outline-danger cursorPointer"
                              (click)="deleteTeam()"
                              ><span class="fa-light fa-trash-alt"></span>
                              {{ "DELETE" | translate }}</span
                              >
                              <span
                                class="btn btn-outline-primary ml-2 cursorPointer"
                                (click)="deleteConfirmation = false"
                                ><span class="fa-light fa-xmark"></span>
                                {{ "CANCEL" | translate }}</span
                                >
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
